import { useEffect } from 'react';

const htmlBody = `
  <div id="sidebar-overlay"></div>

  <div id="app">
    <aside id="sidebar">
      <div class="logo">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
          <polyline points="14 2 14 8 20 8"/>
          <line x1="16" y1="13" x2="8" y2="13"/>
          <line x1="16" y1="17" x2="8" y2="17"/>
          <polyline points="10 9 9 9 8 9"/>
        </svg>
        <span>PDF Editor</span>
      </div>

      <div class="sidebar-section">
        <p class="section-label">ARCHIVO</p>
        <button id="btn-open" class="sidebar-btn primary">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/></svg>
          Abrir PDF
        </button>
        <input type="file" id="file-input" accept=".pdf" hidden />
        <button id="btn-save" class="sidebar-btn" disabled>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
          Guardar PDF
        </button>
        <button id="btn-close" class="sidebar-btn danger" disabled>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          Cerrar archivo
        </button>
      </div>

      <div class="sidebar-section" id="tools-section" style="display:none">
        <p class="section-label">HERRAMIENTAS</p>
        <button class="sidebar-btn tool-btn active" data-tool="select">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 3l14 9-7 1-3 7z"/></svg>
          Seleccionar
        </button>
        <button class="sidebar-btn tool-btn" data-tool="text">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="4 7 4 4 20 4 20 7"/><line x1="9" y1="20" x2="15" y2="20"/><line x1="12" y1="4" x2="12" y2="20"/></svg>
          Agregar Texto
        </button>
        <button class="sidebar-btn tool-btn" data-tool="draw">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 19l7-7 3 3-7 7-3-3z"/><path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z"/><path d="M2 2l7.586 7.586"/><circle cx="11" cy="11" r="2"/></svg>
          Dibujar
        </button>
        <button class="sidebar-btn tool-btn" data-tool="highlight">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 17 9 11 13 15 21 7"/><polyline points="14 7 21 7 21 14"/></svg>
          Resaltar
        </button>
        <button class="sidebar-btn tool-btn" data-tool="image">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
          Insertar Imagen
        </button>
        <input type="file" id="image-input" accept="image/*" hidden />
        <button class="sidebar-btn tool-btn" data-tool="shape">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/></svg>
          Formas
        </button>
        <button class="sidebar-btn tool-btn" data-tool="erase">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 20 4 20"/><path d="M6.3 15.7L3 12.4a1 1 0 0 1 0-1.4L12.4 2a1 1 0 0 1 1.5 0l6.1 6.1a1 1 0 0 1 0 1.4L13.5 16"/></svg>
          Borrador
        </button>
        <button class="sidebar-btn tool-btn" data-tool="text-edit">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
          Editar Texto PDF
        </button>
      </div>

      <div class="sidebar-section" id="options-section" style="display:none">
        <p class="section-label">OPCIONES</p>
        <div class="option-group" id="text-options" style="display:none">
          <label>Fuente</label>
          <select id="font-family">
            <option value="Arial">Arial</option>
            <option value="Times New Roman">Times New Roman</option>
            <option value="Courier New">Courier New</option>
            <option value="Georgia">Georgia</option>
          </select>
          <label>Tamaño</label>
          <input type="number" id="font-size" value="16" min="8" max="96" />
          <label>Color</label>
          <input type="color" id="text-color" value="#000000" />
          <div class="btn-row">
            <button id="btn-bold" class="fmt-btn" title="Negrita"><b>B</b></button>
            <button id="btn-italic" class="fmt-btn" title="Cursiva"><i>I</i></button>
            <button id="btn-underline" class="fmt-btn" title="Subrayado"><u>U</u></button>
          </div>
        </div>
        <div class="option-group" id="draw-options" style="display:none">
          <label>Color de trazo</label>
          <input type="color" id="draw-color" value="#e74c3c" />
          <label>Grosor</label>
          <input type="range" id="draw-size" min="1" max="20" value="3" />
          <span id="draw-size-label">3px</span>
        </div>
        <div class="option-group" id="highlight-options" style="display:none">
          <label>Color</label>
          <div class="color-palette">
            <button class="color-dot active" data-color="rgba(255,235,59,0.5)" style="background:#FFEB3B"></button>
            <button class="color-dot" data-color="rgba(76,175,80,0.5)" style="background:#4CAF50"></button>
            <button class="color-dot" data-color="rgba(33,150,243,0.5)" style="background:#2196F3"></button>
            <button class="color-dot" data-color="rgba(244,67,54,0.5)" style="background:#F44336"></button>
            <button class="color-dot" data-color="rgba(156,39,176,0.5)" style="background:#9C27B0"></button>
          </div>
          <label>Grosor</label>
          <input type="range" id="highlight-size" min="10" max="40" value="20" />
        </div>
        <div class="option-group" id="shape-options" style="display:none">
          <label>Forma</label>
          <div class="shape-picker">
            <button class="shape-btn active" data-shape="rect" title="Rectángulo">&#9645;</button>
            <button class="shape-btn" data-shape="circle" title="Círculo">&#9675;</button>
            <button class="shape-btn" data-shape="line" title="Línea">&#9585;</button>
            <button class="shape-btn" data-shape="arrow" title="Flecha">&#8594;</button>
          </div>
          <label>Color de borde</label>
          <input type="color" id="shape-stroke-color" value="#2196F3" />
          <label>Color de relleno</label>
          <input type="color" id="shape-fill-color" value="#2196F388" />
          <label>Grosor de borde</label>
          <input type="range" id="shape-stroke-size" min="1" max="10" value="2" />
        </div>
        <div class="option-group" id="erase-options" style="display:none">
          <label>Tamaño del borrador</label>
          <input type="range" id="erase-size" min="5" max="60" value="20" />
          <span id="erase-size-label">20px</span>
        </div>
        <div class="option-group" id="text-edit-options" style="display:none">
          <p class="text-edit-hint">Pasa el cursor sobre el PDF para ver los bloques de texto. Haz clic en uno para editarlo.</p>
          <label>Color del texto</label>
          <input type="color" id="text-edit-color" value="#000000" />
        </div>
      </div>

      <div class="sidebar-section" id="pages-section" style="display:none">
        <p class="section-label">PÁGINAS</p>
        <div class="page-controls">
          <button id="btn-prev-page" class="icon-btn" title="Página anterior">&#8592;</button>
          <span id="page-info">1 / 1</span>
          <button id="btn-next-page" class="icon-btn" title="Página siguiente">&#8594;</button>
        </div>
        <button class="sidebar-btn" id="btn-rotate-left">&#8634; Rotar izquierda</button>
        <button class="sidebar-btn" id="btn-rotate-right">&#8635; Rotar derecha</button>
        <button class="sidebar-btn danger" id="btn-delete-page">&#128465; Eliminar página</button>
        <button class="sidebar-btn" id="btn-add-page">+ Agregar página</button>
      </div>

      <div class="sidebar-section" id="view-section" style="display:none">
        <p class="section-label">VISTA</p>
        <div class="zoom-controls">
          <button class="icon-btn" id="btn-zoom-out">&#8722;</button>
          <span id="zoom-level">100%</span>
          <button class="icon-btn" id="btn-zoom-in">+</button>
        </div>
        <button class="sidebar-btn" id="btn-zoom-fit">Ajustar pantalla</button>
        <button class="sidebar-btn" id="btn-undo" disabled>&#8617; Deshacer</button>
        <button class="sidebar-btn" id="btn-redo" disabled>&#8618; Rehacer</button>
      </div>
    </aside>

    <main id="main">
      <div id="toolbar">
        <div class="toolbar-left">
          <button id="btn-menu-toggle" class="icon-btn menu-toggle-btn" title="Menú" aria-label="Abrir menú">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
          </button>
          <span id="file-name">Sin archivo</span>
        </div>
        <div class="toolbar-right">
          <button id="btn-thumbnail-toggle" class="icon-btn" title="Miniaturas">&#9841;</button>
        </div>
      </div>

      <div id="canvas-wrapper">
        <div id="drop-zone">
          <div class="drop-content">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#aaa" stroke-width="1.5">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
              <polyline points="14 2 14 8 20 8"/>
              <line x1="12" y1="18" x2="12" y2="12"/>
              <line x1="9" y1="15" x2="15" y2="15"/>
            </svg>
            <h2>Abre o arrastra un PDF aquí</h2>
            <p>Formatos soportados: PDF</p>
            <button id="btn-open-drop" class="btn-primary-large">Seleccionar archivo</button>
          </div>
        </div>
        <div id="pdf-container" style="display:none">
          <div id="canvas-container">
            <canvas id="pdf-canvas"></canvas>
            <canvas id="annotation-canvas"></canvas>
            <div id="text-layer"></div>
            <div id="annotation-layer"></div>
          </div>
        </div>
      </div>

      <div id="thumbnail-panel" class="hidden">
        <div id="thumbnail-list"></div>
      </div>
    </main>
  </div>

  <div id="mobile-text-overlay">
    <div id="mobile-text-panel">
      <p id="mobile-text-original"></p>
      <input type="text" id="mobile-text-input"
             autocomplete="off" autocorrect="off" autocapitalize="off"
             spellcheck="false" enterkeyhint="done" />
      <div class="mobile-text-actions">
        <button id="mobile-text-cancel" class="modal-btn secondary">&#10007; Cancelar</button>
        <button id="mobile-text-ok" class="modal-btn primary">&#10003; Aceptar</button>
      </div>
    </div>
  </div>

  <div id="text-modal" class="modal hidden">
    <div class="modal-content">
      <h3>Agregar Texto</h3>
      <textarea id="text-input" placeholder="Escribe tu texto aquí..." rows="4"></textarea>
      <div class="modal-actions">
        <button id="btn-text-cancel" class="modal-btn secondary">Cancelar</button>
        <button id="btn-text-confirm" class="modal-btn primary">Agregar</button>
      </div>
    </div>
  </div>

  <div id="loading-overlay" class="hidden">
    <div class="spinner"></div>
    <p>Procesando...</p>
  </div>

  <div id="toast-container"></div>
`;

function PdfEditorPage() {
  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = `${process.env.PUBLIC_URL}/pdf_editor/style.css`;
    link.id = 'pdf-editor-css';
    document.head.appendChild(link);

    const loadScript = (src, id) => new Promise((resolve) => {
      const existing = document.getElementById(id);
      if (existing) existing.remove();
      const s = document.createElement('script');
      s.src = src;
      s.id = id;
      s.onload = resolve;
      s.onerror = resolve;
      document.body.appendChild(s);
    });

    loadScript('https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.min.js', 'pdfjs-script')
      .then(() => loadScript('https://cdnjs.cloudflare.com/ajax/libs/pdf-lib/1.17.1/pdf-lib.min.js', 'pdflib-script'))
      .then(() => loadScript(`${process.env.PUBLIC_URL}/pdf_editor/app.js?v=${Date.now()}`, 'pdfeditor-script'));

    return () => {
      document.getElementById('pdf-editor-css')?.remove();
      document.getElementById('pdfjs-script')?.remove();
      document.getElementById('pdflib-script')?.remove();
      document.getElementById('pdfeditor-script')?.remove();
    };
  }, []);

  return (
    <div
      style={{ position: 'fixed', inset: 0, zIndex: 9999, overflow: 'hidden' }}
      dangerouslySetInnerHTML={{ __html: htmlBody }}
    />
  );
}

export default PdfEditorPage;
